import { TokenUsageMetrics } from 'features/usage/services/usage-service';
import { formatWindow } from 'features/usage/utils/usage-format';
import { UsageActivityCard } from './usage-activity-card';
import { UsageTokenUsageCard } from './usage-token-usage-card';

export function UsageOverview({
  totals,
  periodStart,
  periodEnd,
  periodDays,
  activeDays,
  promptShare,
  completionShare,
  completionRatio,
}: {
  totals: TokenUsageMetrics;
  periodStart: string;
  periodEnd: string;
  periodDays: number;
  activeDays: number;
  promptShare: number;
  completionShare: number;
  completionRatio: string;
}) {
  const dateRange = formatWindow(periodStart, periodEnd);

  return (
    <div className="grid items-stretch gap-x-4 gap-y-6 lg:grid-cols-5">
      <div className="min-w-0 lg:col-span-3 [&>*]:h-full">
        <UsageTokenUsageCard totals={totals} dateRange={dateRange} />
      </div>
      <div className="min-w-0 lg:col-span-2 [&>*]:h-full">
        <UsageActivityCard
          totals={totals}
          dateRange={dateRange}
          periodDays={periodDays}
          activeDays={activeDays}
          promptShare={promptShare}
          completionShare={completionShare}
          completionRatio={completionRatio}
        />
      </div>
    </div>
  );
}
